export default __webpack_public_path__ + "static/media/leafdrops.c4abf117.jpg";